import React from "react";

import { LanguageOutlined } from "@material-ui/icons";
import { Button } from "@material-ui/core";

import en from "../../assets/images/en.svg";
import ua from "../../assets/images/ua.svg";

const LanguageSwitch = ({ onLangChange }) => {
    return (
        <span className="top-bar__lang--row">
            <span className="top-bar__lang--row_icon">
                <LanguageOutlined />
            </span>
            <span className="top-bar__lang--row_text">
                <Button size="small" onClick={() => onLangChange('ru')}>
                    {"РУС"}
                </Button>

                <Button size="small" onClick={() => onLangChange('en')}>
                    {<img src={en} alt="English" height={20} />}
                </Button>

                <Button size="small" onClick={() => onLangChange('ua')}>
                    {<img src={ua} alt="Ukrainian" height={20} />}
                </Button>
            </span>
        </span>
    )
};

export default LanguageSwitch
